// extracted by mini-css-extract-plugin
export var sided = "Image-module--sided--1CJEV";
export var card = "Image-module--card--3OPRZ";
export var contact = "Image-module--contact--2fS2E";
export var accordion = "Image-module--accordion--3Xxb-";